import script from "./DashboardPowerChart.vue?vue&type=script&lang=js"
export * from "./DashboardPowerChart.vue?vue&type=script&lang=js"

export default script